import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      form: {},
      pickerOptions: {
        disabledDate(d) {
          return (
            d.getTime() > Date.now() ||
            d.getTime() <
              moment()
                .subtract(1, "year")
                .valueOf()
          );
        },
      },
    };
  },
  computed: {
    ...mapState({
      options: (state) =>
        _.assign(state.report.options, {
          creative_type: _.map(state.creative.typeInfo, (i) => ({
            label: i.name,
            value: i.type,
          })),
        }),
      report: (state) => state.report.report,
    }),
    intervalOptions() {
      let intervalOptions = [];
      switch (this.form.time_range) {
        case "today":
        case "yesterday":
        case "last7day":
        case "last14day":
          intervalOptions = [
            {
              value: "hour",
              label: "Hour",
            },
            {
              value: "day",
              label: "Day",
            },
          ];
          break;
        case "last30day":
        case "month_to_date":
        case "last_month":
          intervalOptions = [
            {
              value: "day",
              label: "Day",
            },
            {
              value: "month",
              label: "Month",
            },
          ];
          break;
        case "quarter_to_date":
          intervalOptions = [
            {
              value: "month",
              label: "Month",
            },
            {
              value: "quarter",
              label: "Quarter",
            },
          ];
          break;
        case "year_to_date":
          intervalOptions = [
            {
              value: "month",
              label: "Month",
            },
            {
              value: "quarter",
              label: "Quarter",
            },
            // {
            //   value: "year",
            //   label: "Year",
            // },
          ];
          break;
        // case "lifetime":
        //   intervalOptions = [
        //     {
        //       value: "year",
        //       label: "Year",
        //     },
        //   ];
        //   break;
        case "custom":
          const duration = moment(this.form.custom_time_range[1]).diff(
            moment(this.form.custom_time_range[0]),
            "days"
          );
          if (duration <= 15) {
            intervalOptions = [
              {
                value: "hour",
                label: "Hour",
              },
              {
                value: "day",
                label: "Day",
              },
            ];
          } else if (duration <= 30) {
            intervalOptions = [
              {
                value: "day",
                label: "Day",
              },
              {
                value: "month",
                label: "Month",
              },
            ];
          } else if (duration <= 150) {
            intervalOptions = [
              {
                value: "day",
                label: "Day",
              },
              {
                value: "month",
                label: "Month",
              },
              {
                value: "quarter",
                label: "Quarter",
              },
            ];
          } else if (duration <= 730) {
            intervalOptions = [
              {
                value: "month",
                label: "Month",
              },
              {
                value: "quarter",
                label: "Quarter",
              },
              // {
              //   value: "year",
              //   label: "Year",
              // },
            ];
          } else if (duration <= 1800) {
            intervalOptions = [
              {
                value: "quarter",
                label: "Quarter",
              },
              // {
              //   value: "year",
              //   label: "Year",
              // },
            ];
          } else {
            intervalOptions = [
              // {
              //   value: "year",
              //   label: "Year",
              // },
            ];
          }
      }
      if (
        this.form.date_interval &&
        !_.some(intervalOptions, (opt) => opt.value === this.form.date_interval)
      ) {
        this.form.date_interval = intervalOptions[0].value;
      }
      return intervalOptions;
    },
  },
  async created() {
    await this.getOptions();
  },
  mounted() {
    this.initForm();
  },
  methods: {
    ...mapActions({
      getOptions: "report/getOptions",
    }),
    async submit(url = "/api/report") {
      try {
        let params = {
          time_range: this.form.time_range,
          is_header: true,
        };

        if (this.form.date_interval)
          params["group_by_" + this.form.date_interval] = true;
        if (this.form.time_range === "custom") {
          params.from = moment
            .utc(this.form.custom_time_range[0], "YYYY/MM/DD")
            .startOf("day")
            .unix();
          params.to = moment
            .utc(this.form.custom_time_range[1], "YYYY/MM/DD")
            .add(1, "day")
            .startOf("day")
            .unix();
        }

        _.forEach(this.metrics, (metric, metricKey) => {
          metric.forEach((subMetric) => {
            let key = "show_" + subMetric.value;
            params[key] = this.form[key];
          });
        });

        _.forEach(this.dimensions, (dimension) => {
          let key = "group_by_" + dimension.value;
          params[key] = this.form[key];
        });

        _.forEach(this.filters, (filter) => {
          let key = filter.value + "_filter";
          params[key] = Array.isArray(this.form[key])
            ? this.form[key]
            : [this.form[key]];
        });

        await store.dispatch("report/getReport", { url, params });
        if (this.report.rows.length == 0) {
          this.$notify({
            title: "No report.",
            type: "warning",
            position: "bottom-right",
            offset: 20,
          });
        } else {
          this.$notify({
            title: "Success.",
            type: "success",
            position: "bottom-right",
            offset: 20,
          });
        }
      } catch (e) {
        this.$notify.error({
          title: "Error",
          message: "Get report error",
          position: "bottom-right",
          offset: 20,
        });
      }
    },
  },
};
